import { EXPERIMENT_VALIDATION_CONSTANTS } from 'constants/experimentDefaults'


export interface WellData {
  id: number
  outputCells: number
  estimatedFrequency: number
}

export interface ValidationResult {
  isValid: boolean
  errors: string[]
}

export interface WellFieldValidation {
  hasOutputCellsError: boolean
  hasFrequencyError: boolean
}

export const validateWell = (well: WellData, experimentGoal?: 'purity' | 'yield'): WellFieldValidation => {
  const isActive = well.outputCells > 0 || well.estimatedFrequency > 0
  
  // Get the appropriate max cells limit based on experiment goal
  const maxCellsPerWell = experimentGoal === 'purity' 
    ? EXPERIMENT_VALIDATION_CONSTANTS.MAX_CELLS_PER_WELL_PURITY
    : EXPERIMENT_VALIDATION_CONSTANTS.MAX_CELLS_PER_WELL_YIELD
  
  return {
    hasOutputCellsError: isActive && well.outputCells > maxCellsPerWell,
    hasFrequencyError: isActive && (
      well.estimatedFrequency <= EXPERIMENT_VALIDATION_CONSTANTS.MIN_TARGET_FREQUENCY || 
      well.estimatedFrequency >= EXPERIMENT_VALIDATION_CONSTANTS.MAX_TARGET_FREQUENCY
    )
  }
}

export const validateWells = (wells: WellData[], experimentGoal?: 'purity' | 'yield'): ValidationResult => {
  const errors: string[] = []
  
  const maxCellsPerWell = experimentGoal === 'purity' 
    ? EXPERIMENT_VALIDATION_CONSTANTS.MAX_CELLS_PER_WELL_PURITY
    : EXPERIMENT_VALIDATION_CONSTANTS.MAX_CELLS_PER_WELL_YIELD
  
  wells.forEach((well) => {
    const validation = validateWell(well, experimentGoal)
    
    if (validation.hasOutputCellsError) {
      errors.push(`Error: Maximum number of cells per well is ${maxCellsPerWell.toLocaleString()}`)
    }
    
    if (validation.hasFrequencyError) {
      errors.push(`Error: Target frequency must be greater than ${EXPERIMENT_VALIDATION_CONSTANTS.MIN_TARGET_FREQUENCY}% and less than ${EXPERIMENT_VALIDATION_CONSTANTS.MAX_TARGET_FREQUENCY}%.`)
    }
  })
  
  return {
    isValid: errors.length === 0,
    errors: [...new Set(errors)]
  }
}